"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[1326],{

/***/ 674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class ByoBannerController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  trackClick() {
    window.gtag('event', 'BYOB - Banner Link Clicked')
  }
}

Stimulus.register("byo-banner", ByoBannerController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(674)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);